import React from 'react'
import { Button, Col, Form, FormFeedback, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Label, ModalBody, ModalFooter, Row } from 'reactstrap'
import Select from 'react-select';

export const FormSpecialDiscount = (props) => {

    const {
        readOnly, button, methodAction,
        closeDialogSpecialDiscount, loading,
        handleInputChange, handleChangeTypeDiscount, percentage, percentage_global,
        id_exam_include, id_profile_include,
        listExams, listProfiles, listSelectedExams, listSelectedProfiles, handleInputPercentageIndividual,
        handleExamsIncludes, handleProfileIncludes,
        validationsSpecialDiscount, handleSearchChange,
        handleRemoveTest
    } = props;

    const {
        global_special_discount_valid
    } = validationsSpecialDiscount;

    let total_exams = 1;
    let total_profiles = 1; 

    return (
        <>
            <Form role={'form'}>
                <div className="discount-config-card">
                    <Row className="align-items-center">

                        {/* IZQUIERDA */}
                        <Col md="4">
                            <Label className="title">Configuración de descuento</Label>

                            <div className="d-flex align-items-center mt-2">
                                <span className="me-2 mr-1">¿Descuento individual?</span>
                                <Label className='switch m-0'>
                                    <Input 
                                        readOnly={readOnly}
                                        type="checkbox"
                                        name='percentage_global'
                                        checked={percentage_global}
                                        onChange={handleChangeTypeDiscount}
                                    />
                                    <span className='slider round'></span>
                                </Label>
                            </div>
                        </Col>

                        {/* CENTRO (MENSAJE) */}
                        <Col md="5">
                            <div className="info-box">
                                <div className="info-icon">
                                    <i className="fa fa-info"></i>
                                </div>

                                <span>
                                    {
                                        percentage_global
                                            ? "Cada examen o perfil debe tener su descuento individual."
                                            : <>Este porcentaje se aplicará para <b>todos</b> los exámenes y perfiles seleccionados.</>
                                    }
                                </span>
                            </div>
                        </Col>

                        {/* DERECHA (INPUT %) */}
                        <Col md="3">
                            {
                                !percentage_global &&
                                <>
                                    <FormGroup className="percentage-group">
                                        <Label className="percentage-label">PORCENTAJE</Label>

                                        <InputGroup className="custom-input-group">
                                            <Input
                                                className="custom-input"
                                                name="percentage"
                                                value={percentage}
                                                onChange={handleInputChange}
                                                readOnly={readOnly}
                                                invalid={global_special_discount_valid}
                                                placeholder="0"
                                            />

                                            <InputGroupAddon addonType='append'>
                                                <InputGroupText className="custom-addon">
                                                    %
                                                </InputGroupText>
                                            </InputGroupAddon>
                                        </InputGroup>

                                        {
                                            global_special_discount_valid &&
                                            <div className="input-error">
                                                Ingresa un porcentaje válido
                                            </div>
                                        }
                                    </FormGroup>
                                </>
                            }
                        </Col>

                    </Row>
                </div>
                <br />
                <div className='form-section'>
                <Row>
                    <Col sm="6" md="6" lg="6" xl="6">
                        <Row>
                            <Col sm="12" md="12" lg="12">
                                <FormGroup>
                                    <Label className="label-admision-discount d-flex align-items-center gap-2">
                                        <i className="pi pi-search label-icon-discount mr-1"></i>
                                        Selección de exámenes
                                    </Label>

                                    <Select
                                        classNamePrefix={'select'}
                                        name="id_exam_include"
                                        options={listExams}
                                        value={id_exam_include}
                                        placeholder="Selección de exámenes"
                                        isClearable={false}
                                        onChange={(e) => handleExamsIncludes(e)}
                                        onInputChange={(e) => handleSearchChange(e)}
                                        isDisabled={readOnly}
                                        menuPosition="fixed"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className='mt-1'>
                            <Col sm="12" md="12" lg="12">
                                {
                                    listSelectedExams.length > 0
                                        ?
                                        <Label className='label-exam-discount'>Exámenes incluidos dentro de la promoción</Label>
                                        :
                                        <Label className='label-exam-discount'>Ningún examen está incluido</Label>
                                }
                                <hr />
                            </Col>
                        </Row>
                        <Row className='mt-1'>
                            <Col sm="12" md="12" lg="12" className='p-2'>

                                {
                                    listSelectedExams.length > 0 && listSelectedExams.map((exam, key) => {
                                        return (
                                            <div
                                                key={`listExams-${exam.id_exam}`}
                                                className={`exam-row ${exam.is_deleted ? 'd-none' : ''}`}
                                            >

                                                <div className="exam-info">
                                                    <span className="exam-number">
                                                        {exam.is_deleted ? 0 : (total_exams++)}.
                                                    </span>

                                                    <span className="exam-text">
                                                        {exam.name}
                                                    </span>
                                                </div>


                                                {

                                                    percentage_global &&
                                                    <div>

                                                        <div className="exam-actions">

                                                            <div className="input-box">
                                                                <Input
                                                                    type="number"
                                                                    readOnly={readOnly}
                                                                    min={1}
                                                                    max={100}
                                                                    value={exam.percentage || ""}
                                                                    // defaultValue={exam.percentage}
                                                                    onChange={(e) =>
                                                                        handleInputPercentageIndividual(
                                                                            exam.id_exam,
                                                                            e.target.value,
                                                                            "Exam"
                                                                        )
                                                                    }
                                                                    invalid={exam.valid_percentage}
                                                                    className={`input-clean ${exam.valid_percentage ? "" : ""}`}
                                                                />
                                                                <span className="percent-symbol">%</span>
                                                            </div>

                                                            {
                                                                !readOnly &&
                                                                <button
                                                                    type="button"
                                                                    className="btn-delete-clean"
                                                                    onClick={() => handleRemoveTest(exam.id_exam, "Exam")}
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </button>
                                                            }


                                                        </div>

                                                        {
                                                            percentage_global && exam.valid_percentage &&
                                                            <div className="error-text">
                                                                Ingresa un porcentaje de 1 - 100
                                                            </div>
                                                        }

                                                    </div>
                                                }



                                            </div>

                                        )
                                    })}

                            </Col>
                        </Row>
                    </Col>
                    <Col sm="6" md="6" lg="6" xl="6">
                        <Row>
                            <Col sm="12" md="12" lg="12">
                                <FormGroup>
                                    <Label className="label-admision-discount d-flex align-items-center gap-2">
                                        <i className="pi pi-search label-icon-discount mr-1"></i>
                                        Selección de perfiles
                                    </Label>

                                    <Select
                                        classNamePrefix={'select'}
                                        name="id_profile_include"
                                        options={listProfiles}
                                        value={id_profile_include}
                                        placeholder="Selección de perfiles"
                                        isClearable={false}
                                        onChange={(e) => handleProfileIncludes(e)}
                                        isDisabled={readOnly}
                                        menuPosition="fixed"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className='mt-1'>
                            <Col sm="12" md="12" lg="12">
                                {
                                    listSelectedProfiles.length ? <Label className='label-exam-discount'>Perfiles incluidos dentro de la promoción</Label> : <Label className='label-exam-discount' >Ningún perfil está incluido</Label>
                                }
                                <hr />
                            </Col>
                        </Row>
                        <Row className='mt-1'>
                            <Col sm="12" md="12" lg="12" className='p-2'>
                                {
                                    listSelectedProfiles.length > 0 && listSelectedProfiles.map((profile, key) => {
                                        return <div key={`listprofile-${key}`} className={`exam-row ${profile.is_deleted ? 'd-none' : ''}`}>

                                            <div className="exam-info">
                                                <span className="exam-number">
                                                    {profile.is_deleted ? 0 : (total_profiles++)}
                                                </span>

                                                <span className="exam-text">
                                                    {profile.name}
                                                </span>
                                            </div>

                                            {
                                                percentage_global &&

                                                <div>
                                                    <div className="exam-actions">

                                                        <div className="input-box">
                                                            <Input
                                                                type='number'
                                                                readOnly={readOnly}
                                                                min={1}
                                                                max={100}
                                                                value={profile.percentage || ""}
                                                                onChange={(e) => handleInputPercentageIndividual(profile.id_profile, e.target.value, "Profile")}
                                                                invalid={profile.valid_percentage}
                                                                className={`input-clean ${profile.valid_percentage ? "" : ""}`}
                                                            />
                                                            <span className="percent-symbol">%</span>
                                                        </div>

                                                        {
                                                            !readOnly &&
                                                            <button
                                                                type="button"
                                                                className="btn-delete-clean"
                                                                onClick={() => handleRemoveTest(profile.id_profile, "Profile")}

                                                            >
                                                                <i className="fa fa-trash"></i>
                                                            </button>
                                                        }


                                                    </div>

                                                    {
                                                        percentage_global && profile.valid_percentage &&
                                                        <div className="error-text">
                                                            Ingresa un porcentaje de 1 - 100
                                                        </div>
                                                    }

                                                </div>
                                            }



                                        </div>
                                    })
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>

            </Form>
            <ModalFooter>
                 <div className="footer-discount">
                    <Button className={'btn-cancel'} type="button" color='danger' onClick={closeDialogSpecialDiscount}>{readOnly ? "Cerrar visualización" : "Cancelar"}</Button>
                    {
                        !readOnly &&
                        <Button
                            onClick={methodAction}
                           
                            type='button'
                            className={loading ? 'disabled progress-bar-animated progress-bar-striped btn-confirm' : ''}
                        >
                            {button}
                        </Button>
                    }
                </div>
            </ModalFooter>
        </>
    )
}
